webpackJsonp([274115768563236],{

/***/ 773:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/valentines-day/"},"excerpt":"Valentine’s Day is only a couple of weeks away. Remember when you bought your honey that new ironing board? It didn’t go over so well, did…","timeToRead":1,"frontmatter":{"title":"Valentine's Day is Coming!","tags":["birds","holidays","romance"]}}}]}},"pathContext":{"tag":"romance"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-romance-5392d30efdf28661d4e1.js